// @flow

import * as React from "react"
// import Icon from './icon'
import ClassNames from "classnames"
import {withTranslation} from "react-i18next"
import type {BabyState} from "../types"

type Props = {
  babyId: number,
  state: BabyState,
  onClick: () => void,
  t: any,
}

class BabyStateLabel extends React.Component<Props> {
  static defaultProps = {
    onClick: () => {},
  }

  render() {
    const {t, state, onClick} = this.props
    const className = ClassNames("baby-state-label", `state-${state}`)
    return (
      <div className={className} onClick={onClick}>
        {t(`babyCard.babyState.${state}`)}
      </div>
    )
  }
}

export default withTranslation()(BabyStateLabel)
